'use client';

import React, { FC, useEffect, useState } from 'react';
import Image from 'next/image';
import { destroyCookieAction } from '~/app/actions/destroy-cookie-action';
import { getCurrentApplicant } from '~/lib/auth';

interface LogoutLinkProps {
  children: React.ReactNode;
}

export const LogoutLink: FC<LogoutLinkProps> = ({ children }) => {
  // ログアウトの処理に関してはNext.jsの内部のAPIで実装しました
  // サーバーコンポーネントはonClickイベントが使用できない
  // クライアントコンポーネントはクッキーを削除しようとしたところHttpOnlyが有効になっていてクライアントでいじれない

  const BREAK_POINT = 768;
  const [isSp, setIsSp] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSp(window.innerWidth <= BREAK_POINT);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const logout = async () => {
    // セッションと認証用のクッキーを削除
    await fetch('/api/nextjs_api/logout', { method: 'POST' });

    window.location.href = '/login';
  };

  if (isSp) {
    return (
      <span className="c-hamburger__link -arrow-right" onClick={() => logout()}>
        <Image
          alt="ログアウトアイコン"
          src="/nextjs/images/icons/ic_green_logout.svg"
          width="20"
          height="20"
        />
        <p className="u-ml11">{children}</p>
      </span>
    );
  }

  return (
    <span className="l-header__pc-menu-item" onClick={() => logout()}>
      <Image
        alt="ログアウトアイコン"
        src="/nextjs/images/icons/ic_green_logout.svg"
        width="19"
        height="19"
      />
      <p className="u-m0">{children}</p>
    </span>
  );
};
